import { storage } from "./index";
import { o_global } from "../../common/namespaces";
import { GlobalStorage } from "./storage";

/*                                              */
o_global.Storage ||= GlobalStorage;
o_global.globalStorage ||= storage;
